import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import "../Blogs/Post.css";

const Post = () => {
  const textRef = useRef(null); // Reference to the text container
  const sectionRef = useRef(null); // Reference to the section to calculate scroll position

  // Function to split the text into spans for each letter and word
  const splitText = (text) => {
    return text.split(" ").map((word, wordIndex) => (
      <span
        key={wordIndex}
        style={{ display: "inline-block", marginRight: "1rem" }}
      >
        {word.split("").map((letter, letterIndex) => (
          <span key={letterIndex} style={{ display: "inline-block" }}>
            {letter}
          </span>
        ))}
      </span>
    ));
  };

  useEffect(() => {
    const text = textRef.current;
    const letters = text.querySelectorAll("span span"); // Select all the letter spans
    const section = sectionRef.current;

    // Initial state: Position letters in a line with no effects
    gsap.set(letters, {
      scale: 1,
      letterSpacing: "0.5rem",
      x: 0,
      y: 0,
      opacity: 1,
    });

    const handleScroll = () => {
      const scrollY = window.scrollY;
      const sectionTop = section.getBoundingClientRect().top; // Get the position of the section
      const sectionHeight = section.offsetHeight; // Get the height of the section
      const scrollPercentage = (scrollY - sectionTop) / sectionHeight; // Scroll percentage relative to section

      if (scrollPercentage >= 0 && scrollPercentage <= 1) {
        letters.forEach((letter, index) => {
          gsap.to(letter, {
            scale: 1 + scrollPercentage * 2,
            letterSpacing: `${0.5 + scrollPercentage * 4}rem`,
            x: Math.random() * 300 - 150,
            y: Math.random() * 300 - 150,
            opacity: 1 - scrollPercentage,
            ease: "power2.out",
            delay: index * 0.05,
          });
        });

        gsap.to(text, {
          y: 200 * scrollPercentage,
          opacity: 1 - scrollPercentage,
          ease: "power2.out",
        });
      } else {
        letters.forEach((letter, index) => {
          gsap.to(letter, {
            scale: 1,
            letterSpacing: "0.5rem",
            x: 0,
            y: 0,
            opacity: 1,
            ease: "power2.out",
            delay: index * 0.05,
          });
        });

        gsap.to(text, {
          y: 0,
          opacity: 1,
          ease: "power2.out",
        });
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section ref={sectionRef} className="post-bb">
      <img src="/blog.webp" alt="Poster" className="poster-image-bb" />
      <div className="overlay-bb">
        <h1 ref={textRef}>{splitText("Our Popular Blogs")}</h1>
      </div>
    </section>
  );
};

export default Post;
